import React from 'react';
 

export default function PressCard({post = {}, featured = false}){

   const { title = '', content = '', image = '', reference_url = null, reference_name = null, reference_icon = null} = post;

  return (
    <div className={`press-card ${featured ? 'press-card--featured' : ''}`}>
        {reference_url && (
          <a href={reference_url} target="_blank" className='press-card__link'></a>
        )}
      {image && (
        <div className="press-card__image">
          <img src={image} alt={title || ''} />
        </div>
      )}
      <div className="press-card__content">
        <strong className="press-card__reference">
            <img src={reference_icon} alt='' />
            {reference_name}
        </strong>
        {title && (
          <h3 
            className="press-card__title"
            dangerouslySetInnerHTML={{ __html: title }}
          />
        )}
        {content && (
          <p 
            className="press-card__description"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        )}
      </div>
    </div>
  );
};

 